import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import {
  Landing,
  Login,
  ResetPassword,
  PageOverview,
  PageEasyWins,
  PageConsumption,
  VideoLibrary,
  Preferences,
  Rewards,
  AddLocation,
  ContactUs,
  AddRoom,
  FreeProducts,
  ViewLocation,
  EditRoom,
  KitchenTap,
  BathroomTap,
  Urinals,
  Toilets,
  Locations,
  Shower,
  SingleToilet,
  Page404,
  About,
} from '../../pages';
import WebFont from 'webfontloader';
import { Header, Footer, DefaultLayout, BottomNav, Logos } from '../index';
import routes from '../../routes';
import * as _ from 'lodash';
import { useLocation } from 'react-router-dom';
import PrivateRoute from '../PrivateRoute';
import { useResponsivity, utmCheck } from '../../helpers/helpers';
import { isLoggedIn } from '../../helpers/auth';

const theme = {
  flexboxgrid: {
    outerMargin: 1,
    container: {
      sm: 46,
      md: 61,
      lg: 74,
    },
  },
};
const App: React.FC = () => {
  const location = useLocation();

  const isMobile = useResponsivity();
  React.useEffect(() => {
    WebFont.load({
      google: {
        families: ['DM Sans:300,400,500,600,700'],
      },
    });
    utmCheck();
  }, []);

  const builderRoutes = () => {
    return _.map(routes, (route, path) => {
      if (!route.authRequired) {
        return <Route key={path} path={path} element={route.template} />;
      }
    });
  };

  return (
    <ThemeProvider theme={theme}>
      {location.pathname === '/' ? null : <Header />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/about" element={<About />} />
        {builderRoutes()}
        <Route
          element={
            <PrivateRoute>
              <DefaultLayout />
            </PrivateRoute>
          }
        >
          <Route path={'/portal'} element={<PageOverview />} />
          <Route path={'/easy-actions'} element={<PageEasyWins />} />
          <Route path={'/easy-actions/kitchen-tap'} element={<KitchenTap />} />
          <Route
            path={'/easy-actions/bathroom-tap'}
            element={<BathroomTap />}
          />
          <Route path={'/easy-actions/bathroom-shower'} element={<Shower />} />
          <Route path={'/easy-actions/urinals'} element={<Urinals />} />
          <Route
            path={'/easy-actions/dual-flush-toilets'}
            element={<Toilets />}
          />
          <Route path={'/easy-actions/toilets'} element={<Toilets />} />

          <Route
            path={'/easy-actions/single-flush-toilets'}
            element={<SingleToilet />}
          />
          <Route path={'/use'} element={<PageConsumption />} />
          <Route path={'/profile'} element={<Preferences />} />
          <Route path={'/video-library'} element={<VideoLibrary />} />
          <Route path={'/actions'} element={<Rewards />} />
          <Route path={'/:locationId/add-room'} element={<AddRoom />} />
          <Route
            path={'/:locationId/edit-room/:roomId'}
            element={<EditRoom />}
          />
          <Route path={'/locations'} element={<Locations />} />
          <Route path={'/locations/:locationId'} element={<ViewLocation />} />
          <Route path={'/add-location'} element={<AddLocation />} />
          <Route path={'/add-location'} element={<AddLocation />} />
          <Route path={'/ask-me'} element={<ContactUs />} />
          <Route path={'/free-products'} element={<FreeProducts />} />
          <Route path="/*" element={<Page404 />} />
        </Route>
      </Routes>
      {isMobile && isLoggedIn() ? <BottomNav /> : null}
      {location.pathname === '/' || location.pathname === '/login' ? (
        <Logos />
      ) : null}
      <Footer />
    </ThemeProvider>
  );
};

export default App;
